module.exports = new __parcel__URL__("minecraft.e1e2e134.jpg").toString();